import request from "@/utils/request";

// export const login = (data) => {
//   return request({
//     url: '/admin-api/system/auth/login',
//     method: 'post',
//     data: data
//   })
// }

// 新登录
export const login = (data) => {
  return request({
    url: "/app-api/member/auth/login-username",
    method: "post",
    data: data,
  });
};

// 使用租户名，获得租户编号
export const getTenantIdByName = (name) => {
  return request({
    url: `/admin-api/system/tenant/get-id-by-name?name=${name}`,
    method: "get",
  });
};

// 使用租户域名，获得租户信息
export const getTenantByWebsite = (website) => {
  return request({
    url: "/admin-api/system/tenant/get-by-website?website=" + website,
    method: "get",
  });
};

// 获取用户权限信息
// export const getInfo = () => {
//   return request({
//     url: '/admin-api/system/auth/get-permission-info'
//   })
// }

// 获取用户权限信息
export const getInfo = () => {
  return request({
    url: "/app-api/member/user/get",
  });
};

// export const logout = () => {
//   return request({
//     url: '/admin-api/system/auth/logout',
//     method: 'post'
//   })
// }

export const logout = () => {
  return request({
    url: "/app-api/member/auth/logout",
    method: "post",
  });
};

// 获取验证图片以及 token
export const getCode = (data) => {
  return request({
    url: "/admin-api/system/captcha/get",
    method: "post",
    data: data,
  });
};

// 滑动或者点选验证
export const reqCheck = (data) => {
  return request({
    url: "/admin-api/system/captcha/check",
    method: "post",
    data: data,
  });
};
